<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <el-breadcrumb separator="/" class="page-breadcrumb">
        <el-breadcrumb-item>
          <div class="breadcrumb">
            <div class="left"></div>
            <div class="right"><h2>返佣列表</h2></div>
          </div>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div class="page-actions">
        <div class="select">
          <div class="item">
            <div class="txt">合伙人UID</div>
            <div class="ipt">
              <el-input
                placeholder="合伙人UID"
                clearable
                v-model="channelUserId"
              >
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="txt">用户UID</div>
            <div class="ipt">
              <el-input placeholder="用户UID" clearable v-model="userId">
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="txt">合伙人手机或邮箱</div>
            <div class="ipt">
              <el-input
                placeholder="合伙人手机或邮箱"
                clearable
                v-model="telOrEmail"
              >
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="txt">下级手机号或邮箱</div>
            <div class="ipt">
              <el-input
                placeholder="下级手机号或邮箱"
                clearable
                v-model="telOrEmailNext"
              >
              </el-input>
            </div>
          </div>

          <div class="item">
            <div class="txt">租户选择</div>
            <div class="ipt">
              <el-select v-model="tenantId" placeholder="租户选择" clearable>
                <el-option
                  v-for="item in tenantList"
                  :key="item.id"
                  :label="item.tenantName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <!-- <div class="item">
            <div class="txt">邀请人UID</div>
            <div class="ipt">
              <el-input placeholder="邀请人UID" clearable v-model="inviteBy">
              </el-input>
            </div>
          </div> -->

          <!-- <div class="item">
            <div class="txt">注册日期</div>
            <div class="ipt">

    <el-date-picker
            v-model="value1"
            type="daterange"
            align="right"
            format="yyyy - MM - dd 日"
            value-format="yyyy-MM-dd"
            unlink-panels
            :clearable="false"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="changeTime($event)"
            :picker-options="pickerOptions">
          </el-date-picker>
            </div>
          </div> -->
          <!-- <div class="item">
            <el-button size="small" @click="searchYesterday">昨日</el-button>
          </div>
          <div class="item">
            <el-button size="small" @click="searchToday">今日</el-button>
          </div> -->
          <div class="item">
            <el-button size="small" type="primary" @click="handleSearch"
              >查询</el-button
            >
          </div>
        </div>
      </div>
      <user-list @refresh="refreshList"></user-list>
    </el-card>
    <!-- 添加用户信息弹框 -->
  </div>
</template>

<script>
import "./store";
import UserList from "./components/list";
import { mapState, mapActions, mapMutations } from "vuex";
import { QUERY_TYPE, PAGINATION } from "./constants";
import { tenantInfo } from "@/common/publicApi";
import moment from "moment";
export default {
  name: "UnderUser",
  components: {
    UserList,
  },
  data() {
    return {
      value2: "",
      dialogVisible: false,
      userId: "",
      telOrEmail: "",
      telOrEmailNext: "",
      channelId: "",
      channelUserId: "",
      inviteBy: "",
      value1: "",
      tenantList: [],
      tenantId: "",
      //  value1: [(moment(new Date().getTime() - 7 * 1000 * 24 * 60 * 60).format('YYYY-MM-DD')),new Date().getFullYear()+'-'+(new Date().getMonth()+1)+'-'+new Date().getDate()],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近半年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("rebate", ["queryType", "pagination"]),
    ...mapState(["userInfo"]),
  },
  methods: {
    ...mapActions("rebate", ["list", "addUser"]),
    ...mapMutations("rebate", ["setQueryType"]),
    refreshList(data = {}) {
      this.list({
        telOrEmail: this.telOrEmail,
        telOrEmailNext: this.telOrEmailNext,
        channelUserId: this.channelUserId,
        userId: this.userId,
        tenantId: this.tenantId,
        ...this.pagination,
        ...data,
      });
    },
    changeTime(e) {
      this.list({
        telOrEmail: this.telOrEmail,
        telOrEmailNext: this.telOrEmailNext,
        channelUserId: this.channelUserId,
        userId: this.userId,
        tenantId: this.tenantId,
        ...PAGINATION,
      });
    },
    searchYesterday() {
      this.value1 = [
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          "YYYY-MM-DD"
        ),
        moment(new Date().getTime() - 1 * 1000 * 24 * 60 * 60).format(
          "YYYY-MM-DD"
        ),
      ];
      this.handleSearch();
    },
    searchToday() {
      this.value1 = [
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate(),
        new Date().getFullYear() +
          "-" +
          (new Date().getMonth() + 1) +
          "-" +
          new Date().getDate(),
      ];
      this.handleSearch();
    },
    handleSearch() {
      this.list({
        telOrEmail: this.telOrEmail,
        telOrEmailNext: this.telOrEmailNext,
        channelUserId: this.channelUserId,
        userId: this.userId,
        tenantId: this.tenantId,
        ...PAGINATION,
      });
    },
    handleSave() {},
    closeDialog() {
      this.dialogVisible = false;
    },
    onOpen() {},
    onClose() {
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
    close() {
      // this.$emit("update:visible", false);
      this.$refs["elForm"].resetFields();
      this.dialogVisible = false;
    },
  },
  mounted() {
    tenantInfo().then((res) => {
      if (res.code == 0) {
        this.tenantList = res.data;
      }
    });
    if (this.$route.query.channelUserId) {
      this.channelUserId = this.$route.query.channelUserId;
      this.handleSearch();
    } else {
      this.handleSearch();
    }
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
